<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
  <rect x="1.5" y="5.5" width="2" height="6" rx="0.75" fill="#E5E5E5"/>
  <rect x="3.5" y="6.5" width="1.2" height="4" rx="0.5" fill="#E5E5E5"/>
  <rect x="4.7" y="7.7" width="7.6" height="1.6" rx="0.5" fill="#E5E5E5"/>
  <rect x="12.3" y="6.5" width="1.2" height="4" rx="0.5" fill="#E5E5E5"/>
  <rect x="13.5" y="5.5" width="2" height="6" rx="0.75" fill="#E5E5E5"/>
</svg>
